import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { BUTTON_TYPES } from 'src/app/components/shared/modal/components/modal-frame/modal-frame.constants';
import { BUTTON_CLICK } from 'src/app/components/shared/modal/exit-modal/exit-modal.constants';
import { WarningModalInput } from 'src/app/components/shared/modal/warning-modal/warning-modal.constants';
import { SpecialCharacters } from 'src/app/core/enums';
import { OutboundGLEService } from 'src/app/core/services/position-operations/outbound-gle/outbound-gle.service';
import { CommonUtils } from 'src/app/core/utils/common/common.utils';
import { DataUtils } from 'src/app/core/utils/data/data.utils';
import { CONST, Ids, TYPE_OPTIONS } from '../outbound-scan-gle.constant';

@Component({
  selector: 'app-transfer-uld-modal',
  templateUrl: './transfer-uld-modal.component.html',
  styleUrls: ['./transfer-uld-modal.component.scss'],
  standalone: false,
})
export class TransferUldModalComponent implements OnInit {
  readonly CONST = {
    ...CONST.TRANSFER_ULD_MODAL,
    ...CONST,
  };
  readonly IDS = Ids;
  readonly TYPE_OPTIONS = TYPE_OPTIONS;
  readonly BUTTON_TYPES = BUTTON_TYPES;
  readonly SpecialCharacters = SpecialCharacters;

  transferUldForm!: FormGroup;
  warningDialogData: WarningModalInput = {
    header: this.CONST.MODAL.HEADER,
    body: `${this.CONST.MODAL.LINE1} <br/> ${this.CONST.MODAL.LINE2}`,
    confirmButtonText: this.CONST.MODAL.CONFIRM_BUTTON,
    rejectButtonText: this.CONST.MODAL.REJECT_BUTTON,
  };
  constructor(
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: FormGroup['value'],
    public dialogRef: MatDialogRef<TransferUldModalComponent>,
    private dialog: MatDialog,
    private dataUtils: DataUtils,
    private commonUtils: CommonUtils,
    private outboundService: OutboundGLEService,
  ) {}

  ngOnInit(): void {
    this.initForm();
  }
  /**
   * Used to define form
   *
   * @memberof TransferUldModalComponent
   */
  initForm() {
    this.transferUldForm = this.fb.group({
      [Ids.EQUIPMENT_NUMBER]: ['', Validators.compose([Validators.required])],
      [Ids.EQUIPMENT_TYPE]: [null, Validators.compose([Validators.required])],
    });
  }
  /**
   * Used to transfer submit with form value
   *
   * @memberof TransferUldModalComponent
   */
  transfer() {
    const formData = this.transferUldForm.value;
    this.outboundService
      .postTransferULOs({
        toUld: {
          type: formData[this.IDS.EQUIPMENT_TYPE],
          number: formData[this.IDS.EQUIPMENT_NUMBER],
        },
        ulo: this.data.ulo.rawUlo,
      })
      .subscribe((res) => {
        this.dialogRef.close({ transfer: this.transferUldForm.value, res });
      });
  }

  /**
   * used to close modal and reopen popup if REJECT button click
   *
   * @param {string} event
   * @memberof TransferUldModalComponent
   */
  onClose(event: string) {
    this.dialogRef.close(this.transferUldForm.value);

    if (event === BUTTON_CLICK.REJECT) {
      this.reOpenTransferULDPopup();
    }
  }
  /**
   * used to reopen transfer uld popup
   *
   * @memberof TransferUldModalComponent
   */
  reOpenTransferULDPopup() {
    this.dialog
      .open(TransferUldModalComponent, {
        width: '34.25rem',
        disableClose: true,
        data: this.transferUldForm.value,
      })
      ?.afterClosed()
      .subscribe((resp) => {
        if (resp && resp?.transfer) {
          this.dataUtils.transferUld$.next(resp);
        }
      });
  }
  /**
   * used to show cancel warning modal
   *
   * @memberof TransferUldModalComponent
   */
  cancel() {
    this.commonUtils
      .openWarningModal({
        header: this.CONST.CANCEL_MODAL.HEADER,
        body: this.CONST.CANCEL_MODAL.BODY,
        confirmButtonText: this.CONST.CANCEL_MODAL.CONFIRM_BUTTON,
        rejectButtonText: this.CONST.CANCEL_MODAL.REJECT_BUTTON,
        extraClass: 'large-confirm-btn',
      })
      .afterClosed()
      .subscribe((resp) => {
        if (resp.button === BUTTON_CLICK.ACCEPT) {
          this.dialogRef.close();
        }
      });
  }
}
